import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom"
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import tag from "../images/tag.png";

const AstrologerCardFile = ({ data }) => {
  const navigate = useNavigate();

  const astrologerChats = ["AcharyaPrem"];
  const [contactNo, setContactNo] = useState('');
  const [astrologers, setAstrologers] = useState([]);

  useEffect(() => {
    const fetchAstrologers = async () => {
      try {
        const response = await fetch("https://app.astrovedaguru.com/api/getAstrologer", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const jsonData = await response.json();
        console.log("Fetched data:", jsonData);


        setAstrologers(jsonData.recordList);

      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchAstrologers();

  }, []);

  const handleCardClick = (astrologer) => {
    if (astrologerChats.length > 0) {
      if (astrologer.contactNo) {
        alert('sss');
        setContactNo(astrologer.contactNo);
        sendContactNumber(astrologer.contactNo);
      }
      const formattedName = astrologer.name.toLowerCase().replace(/\s+/g, '-'); // Format name to lowercase and replace spaces with dashes
      navigate(`/${formattedName}`, { state: { astrologerData: astrologer } });
    }
  };

  const sendContactNumber = async (contactNumber) => {
    try {
      const response = await fetch('https://app.astrovedaguru.com/api/loginAppAstrologer', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ contactNo: contactNumber }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const jsonData = await response.json();
      console.log('API response:', jsonData);
      
    } catch (error) {
      console.error('Error sending contact number:', error);
    }
  };


  return (
    <>
      {astrologers.map((element) => {
        console.log(":Profile Image URL", element.profileImage); 
        return (
          <div className="col-lg-6 col-md-4 col-sm-12" key={element.id}>
            <div className="card card8 mb-3" >
              <div className="row g-0">
              {/* <div className='col-3'>
                  <img src={tag} className="tag"/>
                </div> */}
                <div className="col-3">
                 <img src={`https://app.astrovedaguru.com/${element.profileImage}`} className="card-img-top" alt="" />
                </div>
                
                <div className="col-1"></div>
                <div className="col-8">
                  <div className="card8-content">
                    <h5 className="card-title name">{element.name}</h5>
                    <p className="rates">
                      <CurrencyRupeeIcon sx={{ fontSize: '14px', marginBottom: '3px' }} />
                      {element.charge}
                    </p>
                  </div>
                  <p className="exp">
                    <b>Experience:</b> {element.experienceInYears} years
                  </p>
                  <p className="language">
                    <b>Language:</b> {element.languageKnown}
                  </p>
                  <p className="expertise">
                    <b>Expertise:</b> {element.primarySkill}
                  </p>
                  <button
                    type="button"
                    className="btn btn-warning buynow"
                    onClick={() => handleCardClick(element)}
                  >
                    Call Now
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default AstrologerCardFile;